import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../../common/http/http-utils';

@Injectable()
export class Service {
  result:any = '';

  constructor(public http: HttpClient) {
  }

  configureEmailVapp(vdcId, vappId, emailObj) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcId + '/vapp/' + vappId + '/emailIds';
    return this.http
      .post(url, JSON.stringify(emailObj))
      .map(
        res => this.result = res
      );
  }

  configureEmailVDC(vdcId, emailObj) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcId + '/emailIds';
    return this.http
      .post(url, JSON.stringify(emailObj))
      .map(
        res => this.result = res
      );
  }

  getEmailVapp(vdcId, vappId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcId + '/vapp/' + vappId + '/emailIds';
    return this.http
      .get(url)
      .map(
        res => this.result = res
      );
  }

  getEmailVDC(vdcId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcId + '/emailIds';
    return this.http
      .get(url)
      .map(
        res => this.result = res
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/configure-email/configure-email.service.ts